import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w-18 fixed bottom-0 flex items-center pb-2" }
const _hoisted_2 = {
  href: "https://www.oculai.de/impressum",
  class: "group flex pr-6 text-xs text-gray-500 2xl:text-sm"
}
const _hoisted_3 = {
  href: "https://www.oculai.de/datenschutz",
  class: "group flex pr-6 text-xs text-gray-500 2xl:text-sm"
}
const _hoisted_4 = ["value"]

import { ArrowTopRightOnSquareIcon } from "@heroicons/vue/24/solid";
import { ref, onMounted, watch } from "vue";

interface Language {
  id: number;
  name: string;
  identifier: string;
  icon: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const languages: Language[] = [
  { id: 1, name: "Deutsch", identifier: "de", icon: "de" },
  { id: 2, name: "English", identifier: "en", icon: "gb" },
  { id: 3, name: "Français", identifier: "fr", icon: "fr" },
];

const selectedLanguage = ref<Language | null>(null);

const changeLanguage = () => {
  if (selectedLanguage.value) {
    localStorage.setItem("lang", selectedLanguage.value.identifier);
    window.location.reload();
  }
};

const loadLanguage = () => {
  const storedLang = localStorage.getItem("lang") || "de";
  selectedLanguage.value = languages.find((lang) => lang.identifier === storedLang) || languages[0];
};

watch(selectedLanguage, (newLang) => {
  if (newLang) {
    localStorage.setItem("lang", newLang.identifier);
  }
});

onMounted(loadLanguage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", _hoisted_2, [
      _createVNode(_unref(ArrowTopRightOnSquareIcon), {
        class: "mr-1 flex h-4 w-4",
        "aria-hidden": "true"
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.$t("authentication.login.imprint")), 1)
    ]),
    _createElementVNode("a", _hoisted_3, [
      _createVNode(_unref(ArrowTopRightOnSquareIcon), {
        class: "mr-1 flex h-4 w-4",
        "aria-hidden": "true"
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.$t("authentication.login.data_protection")), 1)
    ]),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("select", {
        id: "language",
        name: "language",
        class: "focus:outline-none mt-1 block w-full border-gray-300 py-2 pl-3 pr-10 text-xs focus:border-gray-500 focus:ring-gray-500",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedLanguage).value = $event)),
        onChange: changeLanguage
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(languages, (lang) => {
          return _createElementVNode("option", {
            key: lang.id,
            value: lang
          }, _toDisplayString(lang.name), 9, _hoisted_4)
        }), 64))
      ], 544), [
        [_vModelSelect, selectedLanguage.value]
      ])
    ])
  ]))
}
}

})